/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import useSelectValue from 'hooks/useSelectValue';
import {
  apiGetFileDeletedByProductProfile,
  apiRestoreFileByProductProfile,
  apiDeletePermanentlyByProductProfile,
} from 'api';

const transformData = (files) => {
  const transform = files.reduce((acc, current) => {
    const parents = files.filter(({ id }) => current.parentId === id);
    const subChildren = transformData(files.filter(({ parentId }) => parentId === current.id));
    if (!parents.length) {
      acc.push({ ...current, children: subChildren });
      return acc;
    }
    const parentIndex = acc.findIndex(({ id }) => id === current.parentId);
    if (parentIndex > -1) {
      // If current File folder have parent created before.
      const parent = { ...acc[parentIndex] };
      const existedIndex = parent.children.findIndex(({ id }) => id === current.id);
      if (existedIndex > -1) {
        const existed = { ...parent.children[existedIndex] };
        parent.children.splice(existedIndex, {
          ...existed,
          children: existed.children.concat(subChildren),
        });
        acc.splice(parentIndex, 1, {
          ...parent,
        });
        return acc;
      }
      acc.splice(parentIndex, 1, {
        ...parent,
        children: parent.children.concat(subChildren),
      });
      // if the current not existed in children of parent
      return acc;
    }
    return acc;
  }, []);
  return transform;
};
const getAllChildren = (folder, files = []) => {
  let _files = [...files, folder.id];
  const { children: folderChildren } = folder;
  if (!folderChildren.length) {
    return _files;
  }
  for (let i = 0; i < folderChildren.length; i += 1) {
    _files = getAllChildren(folderChildren[i], _files);
  }
  return _files;
};
const convertFileFolderToIds = (items) => {
  return items.reduce((acc, current) => {
    const files = getAllChildren(current, []);
    return acc.concat(files);
  }, []);
};

export const ProductBinManagementContext = React.createContext({});

export const ProductBinManagementProvider = ({ productId, children, autoFetch = true }) => {
  const [data, setData] = React.useState([]);
  const [transformedData, setTransformedData] = React.useState([]);
  const [selected, setSelected, isChecked, handleSelect] = useSelectValue([]);

  const fetchData = async () => {
    const response = await apiGetFileDeletedByProductProfile(productId);
    const { status } = response || {};
    if (status === 200) {
      const { deletedFiles } = response.data;
      // response
      setTransformedData(transformData(deletedFiles));
      setData(deletedFiles);
    } else {
      throw response;
    }
  };

  const emptyBin = async (cb) => {
    const ids = data.map(({ id }) => id);
    try {
      const response = await apiDeletePermanentlyByProductProfile(productId, ids);
      const { status } = response || {};
      if (status === 200) {
        fetchData();
        cb && cb();
      } else {
        throw response;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const deletePermanently = async (items, cb) => {
    const ids = convertFileFolderToIds(items);
    try {
      const response = await apiDeletePermanentlyByProductProfile(productId, ids);
      const { status } = response || {};
      if (status === 200) {
        fetchData();
        cb && cb();
      } else {
        throw response;
      }
    } catch (error) {
      console.error(error);
    }
  };
  const restoreFileByIds = async (ids, cb) => {
    try {
      const response = await apiRestoreFileByProductProfile(productId, ids);
      const { status } = response || {};
      if (status === 200) {
        fetchData();
        cb && cb();
      } else {
        throw response;
      }
    } catch (error) {
      console.error(error);
    }
  };
  const restoreFile = async (items, cb) => {
    const ids = convertFileFolderToIds(items);
    try {
      await restoreFileByIds(ids, cb);
      // const response = await apiRestoreFileByProductProfile(productId, ids);
      // const { status } = response || {};
      // if (status === 200) {
      //   fetchData();
      //   cb && cb();
      // } else {
      //   throw response;
      // }
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    if (autoFetch) {
      fetchData();
    }
  }, []);

  React.useEffect(() => {
    return () => {
      setData([]);
      setTransformedData([]);
      setSelected([]);
    };
  }, []);

  return (
    <ProductBinManagementContext.Provider
      value={{
        data,
        transformedData,
        selected,
        setSelected,
        isChecked,
        handleSelect,
        fetchData,
        emptyBin,
        deletePermanently,
        restoreFile,
        restoreFileByIds
      }}>
      {children}
    </ProductBinManagementContext.Provider>
  );
};
